<template>
  <v-row justify="center">
    <v-data-table
      v-if="chartType === 'yearly' && table"
      class="elevation-15"
      :headers="tableHeaders"
      :items="table"
      multi-sort
      :sort-by="chartHeaders.slice(0, 2)"
    >
      <template v-slot:item="{ item, headers }">
        <tr>
          <td v-for="header in headers" :key="header.value">
            {{ item[header.value] || labels.noData }}
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-container
      class="chart-container"
      v-if="chartType !== 'yearly'"
    >
      <trend-chart
        class="trend-chart"
        v-for="chart in chartData"
        :key="chart.variable.id"
        :chart="chart"
        :chart-type="chartType"
        :height="getChartHeight(chart)"
      />
    </v-container>

  </v-row>
</template>

<script>
import { isArrEmpty } from '@/helpers';
import { labels } from '@/assets/texts.json';

const TrendChart = () => import('@/components/TrendChart.vue');


export default {
  name: 'StatsResults',
  components: {
    TrendChart,
  },
  props: {
    // datos estadísticos a representar
    chartData: {
      type: Array[Object],
      default: () => [],
    },
    // tipo de informe a representar
    chartType: {
      type: String,
      default: '',
    },
    // [opcional] cabecera de las tablas de datos
    chartHeaders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      labels,
    };
  },
  computed: {
    table() {
      return this.chartType === 'yearly'
        ? this.chartData.map((chart) => (({
          year,
          plot,
          crop,
          variables,
        }) => (
          {
            Año: year,
            Parcela: plot.label || plot['ref-catastral'],
            Cultivo: crop,
            ...Object.fromEntries(isArrEmpty(variables)
              ? variables
              : variables.map((v) => [v.name, v.value])),
          })
        )(chart))
        : [];
    },
    tableHeaders() {
      return this.chartType === 'yearly'
        ? this.chartHeaders.map((header) => {
          if (typeof header === 'object') {
            return header;
          }
          return {
            text: header,
            value: header,
          };
        })
        : {};
    },
  },
  methods: {
    getChartHeight(chart) {
      return 380 + chart.series.length * 5;
    },
  },
};
</script>

<style lang="scss">
.v-data-table-header {
  background-color: var(--v-primary-darken2);
  & > tr th, .v-data-table-header__icon, .v-data-table-header__sort-badge {
    color: white !important;
  }
}
.chart-container {
  width: 100%;
}
.trend-chart {
  width: 100%;
  min-height: 400px;
  max-width: 1096px;
  margin: auto;
}
</style>
